import DashboardLayout from "@/components/DashboardLayout";
import { PlaygroundLayout } from "./components/playground-layout";
import { useTranslation } from "react-i18next";
import { LegacyPlaygroundRoutingProvider } from "./routing/react-router-playground-routing";

export const PlaygroundContent = ({
  singleRenderedChildren = false,
}: {
  singleRenderedChildren?: boolean;
}) => (
  <PlaygroundLayout singleRenderedChildren={singleRenderedChildren} />
);

export const Playground = ({
  singleRenderedChildren = false,
}: {
  singleRenderedChildren?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <LegacyPlaygroundRoutingProvider>
      <DashboardLayout
        title={t("playground.aiChat")}
        fullHeight
        singleRenderedChildren={singleRenderedChildren}
      >
        <PlaygroundContent
          singleRenderedChildren={singleRenderedChildren}
        />
      </DashboardLayout>
    </LegacyPlaygroundRoutingProvider>
  );
};
